// <countdown-launch data-target="2026-06-05T00:00:00+02:00">
// Updates day/hour/minute/second values every second until the target is reached,
// then swaps to a "launching soon" fallback message.
(function () {
  if (customElements.get('countdown-launch')) return;

  class CountdownLaunch extends HTMLElement {
    connectedCallback() {
      const targetAttr = this.getAttribute('data-target');
      this.target = targetAttr ? new Date(targetAttr).getTime() : NaN;

      if (Number.isNaN(this.target)) {
        this.markLaunched();
        return;
      }

      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      this.update();
      this.intervalId = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    update() {
      const now = Date.now();
      const remaining = this.target - now;

      if (remaining <= 0) {
        this.markLaunched();
        return;
      }

      const seconds = Math.floor(remaining / 1000);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      this.setValue(this.daysEl, days);
      this.setValue(this.hoursEl, hours, true);
      this.setValue(this.minutesEl, minutes, true);
      this.setValue(this.secondsEl, secs, true);
    }

    setValue(el, value, pad) {
      if (!el) return;
      const str = pad ? String(value).padStart(2, '0') : String(value);
      if (el.textContent !== str) el.textContent = str;
    }

    markLaunched() {
      this.classList.add('is-launched');
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }

  customElements.define('countdown-launch', CountdownLaunch);
})();
